import { render, staticRenderFns } from "./RegistroEntradaList.vue?vue&type=template&id=f8c37996&scoped=true"
import script from "./RegistroEntradaList.vue?vue&type=script&lang=js"
export * from "./RegistroEntradaList.vue?vue&type=script&lang=js"
import style0 from "./RegistroEntradaList.vue?vue&type=style&index=0&id=f8c37996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c37996",
  null
  
)

export default component.exports